import React, { useState } from 'react';

const ProcessPdfViewer = ({ pdfPath }) => {
  const [error, setError] = useState(false);

  // Use local PDF file path - URL encode to handle spaces
  const defaultPdfPath = '/processes/PrattPAper LGL2023 Material Requisition Process 20230407.pdf';
  const pdfUrl = pdfPath ? encodeURI(pdfPath) : encodeURI(defaultPdfPath);

  return (
    <div style={{
      width: '100%',
      height: 'calc(100vh - 200px)',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      {/* Header */}
      <div style={{
        padding: '1rem 1.5rem',
        backgroundColor: 'white',
        borderBottom: '1px solid #dee2e6',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.5rem', color: '#333' }}>
            ⚙️ Process Documentation
          </h2>
          <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.9rem', color: '#666' }}>
            View process documentation and workflows
          </p>
        </div>
        <a
          href={pdfUrl}
          download
          style={{
            padding: '0.5rem 1rem',
            backgroundColor: '#dc3545',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '6px',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'background-color 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#c82333';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#dc3545';
          }}
        >
          📥 Download PDF
        </a>
      </div>

      {/* PDF Viewer */}
      <div style={{
        flex: 1,
        position: 'relative',
        backgroundColor: '#e9ecef',
        overflow: 'hidden'
      }}>
        {error ? (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            padding: '2rem',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📄</div>
            <h3 style={{ color: '#495057', marginBottom: '0.5rem' }}>
              Unable to Load PDF
            </h3>
            <p style={{ color: '#6c757d', marginBottom: '1.5rem' }}>
              The PDF file could not be loaded. Please check the file path or ensure the file exists.
            </p>
            <div style={{
              padding: '1rem',
              backgroundColor: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '6px',
              maxWidth: '500px'
            }}>
              <p style={{ margin: 0, fontSize: '0.85rem', color: '#856404' }}>
                <strong>Expected path:</strong> {pdfUrl}
              </p>
              <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.85rem', color: '#856404' }}>
                Place your PDF file in the <code>public/processes/</code> directory or update the path in the component.
              </p>
            </div>
          </div>
        ) : (
          <iframe
            src={pdfUrl}
            style={{
              width: '100%',
              height: '100%',
              border: 'none'
            }}
            title="Process Documentation PDF"
            onError={() => setError(true)}
          />
        )}
      </div>
    </div>
  );
};

export default ProcessPdfViewer;

